export enum ErrorMessages {
  NoServicesSelected = 'NoServicesSelected',
  SomethingWentWrong = 'SomethingWentWrong',
  FieldEmpty = 'FieldEmpty',
}
